(function() {
    "use strict";
    var catalogScript = document.currentScript, catalogScriptUrl = catalogScript ? new URL(catalogScript.src) : null, assetRoot = catalogScriptUrl ? new URL(".", catalogScriptUrl).href : "", assetVersion = catalogScriptUrl ? catalogScriptUrl.search : "", cartKey = "fronto_king_wholesale_order_v2", legacyCartKey = "fronto_king_review_order_v1", inMemoryCart = {}, activeProduct = null, activeAudience = "consumer", lastFocusedNode = null;
    function catalog() {
        return window.FrontoKingCatalog || {
            categories: [],
            products: []
        };
    }
    function escapeHtml(value) {
        return String(value ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
    }
    function imageUrl(filename) {
        if (!filename) return "";
        var url = new URL(filename, assetRoot);
        return assetVersion && (url.search = assetVersion), url.href;
    }
    function route(name) {
        var local = /127\.0\.0\.1|localhost/.test(window.location.hostname) || window.location.pathname.indexOf("/clickthrough") !== -1;
        return name === "locator" ? local ? "#/store-locator" : "/pages/store-locator" : name === "wholesale" ? local ? "#/wholesale" : "/pages/us-distributors" : name === "cart" ? local ? "#/cart" : "/cart" : local ? "#/shop" : "/collections/all";
    }
    function categoryById(id) {
        return catalog().categories.find(function(category) {
            return category.id === id;
        });
    }
    function productById(id) {
        return catalog().products.find(function(product) {
            return product.id === id;
        });
    }
    function pairImage(product) {
        return product.displayImage.replace("-display.jpg", "-pair.jpg");
    }
    function packageUnits(product) {
        var match = String(product.format || "").match(/(\d+)-count display\s*\/\s*(\d+)-count master case/i);
        return {
            display: match ? Number(match[1]) : null,
            masterCase: match ? Number(match[2]) : null
        };
    }
    function unitLabel(product, unit, includeCount) {
        var units = packageUnits(product);
        return unit === "master_case" ? (includeCount && units.masterCase ? units.masterCase + "-count " : "") + "master case" : (includeCount && units.display ? units.display + "-count " : "") + "display";
    }
    function productCard(product, audience) {
        var category = categoryById(product.category), isWholesale = audience === "wholesale", detailCopy = isWholesale ? product.format : "Explore the package and find it at a retailer near you.", actions = isWholesale ? '<div class="fk-catalog-card__actions fk-catalog-card__actions--wholesale"><button class="fk-button fk-button--outline-dark fk-catalog-card__view-button" type="button" data-fk-quickview="' + escapeHtml(product.id) + '" data-fk-audience="wholesale">View package</button><button class="fk-button fk-button--gold" type="button" data-fk-add="' + escapeHtml(product.id) + '" data-fk-unit="display">Add display</button><button class="fk-button fk-button--gold" type="button" data-fk-add="' + escapeHtml(product.id) + '" data-fk-unit="master_case">Add master case</button></div>' : '<div class="fk-catalog-card__actions"><button class="fk-button fk-button--outline-dark" type="button" data-fk-quickview="' + escapeHtml(product.id) + '" data-fk-audience="consumer">View product</button><a class="fk-button fk-button--gold" href="' + route("locator") + '">Find a retailer</a></div>';
        return '<article class="fk-product-card fk-catalog-card" data-fk-product-card="' + escapeHtml(product.id) + '" data-fk-audience="' + escapeHtml(audience) + '"><button class="fk-product-card__media fk-catalog-card__image" type="button" data-fk-quickview="' + escapeHtml(product.id) + '" data-fk-audience="' + escapeHtml(audience) + '" aria-label="View ' + escapeHtml(product.name) + ' images"><img src="' + imageUrl(pairImage(product)) + '" alt="Fronto King ' + escapeHtml(product.name) + ' display and package front" width="1360" height="960" loading="lazy"><span class="fk-catalog-card__view">View</span></button><div class="fk-product-card__body"><p class="fk-kicker">' + escapeHtml(category ? category.label : "Fronto King") + "</p><h3>" + escapeHtml(product.name) + '</h3><p class="fk-catalog-card__format">' + escapeHtml(detailCopy) + "</p>" + actions + "</div></article>";
    }
    function categoryNavigation(container) {
        return catalog().categories.map(function(category) {
            var count = catalog().products.filter(function(product) {
                return product.category === category.id;
            }).length, href = "#" + category.id;
            return container.dataset.fkNavMode === "preview" ? href = "#/shop?category=" + encodeURIComponent(category.id) : container.dataset.fkNavMode === "preview-wholesale" ? href = "#/wholesale?category=" + encodeURIComponent(category.id) : container.dataset.fkNavBase && (href = container.dataset.fkNavBase + "#" + category.id), 
            '<a href="' + href + '"><strong>' + escapeHtml(category.label) + "</strong><span>" + count + "</span></a>";
        }).join("");
    }
    function renderCategoryNav(container) {
        container.innerHTML = categoryNavigation(container);
    }
    function renderCatalog(container) {
        var mode = container.dataset.mode || "grid", limit = Number(container.dataset.limit || 0), audience = container.dataset.audience || "consumer", products = catalog().products.slice();
        if (mode === "featured" && (products = products.filter(function(product) {
            return product.featured;
        })), container.dataset.category && (products = products.filter(function(product) {
            return product.category === container.dataset.category;
        })), limit > 0 && (products = products.slice(0, limit)), mode !== "grouped") {
            container.innerHTML = '<div class="fk-product-grid">' + products.map(function(product) {
                return productCard(product, audience);
            }).join("") + "</div>";
            return;
        }
        container.innerHTML = catalog().categories.map(function(category) {
            var categoryProducts = products.filter(function(product) {
                return product.category === category.id;
            });
            return '<section class="fk-catalog-group" id="' + escapeHtml(category.id) + '"><div class="fk-catalog-group__heading"><div><p class="fk-kicker">' + (audience === "wholesale" ? "Wholesale catalog" : "Fronto King products") + "</p><h2>" + escapeHtml(category.label) + "</h2><p>" + escapeHtml(category.copy) + "</p></div><strong>" + categoryProducts.length + ' products</strong></div><div class="fk-product-grid">' + categoryProducts.map(function(product) {
                return productCard(product, audience);
            }).join("") + "</div></section>";
        }).join("");
        var hashCategory = window.location.hash.replace("#", ""), matchesCategory = catalog().categories.some(function(category) {
            return category.id === hashCategory;
        });
        matchesCategory && window.requestAnimationFrame(function() {
            var target = document.getElementById(hashCategory);
            target && target.scrollIntoView({
                block: "start"
            });
        });
    }
    function renderInstagram(container) {
        var items = window.FrontoKingInstagram || [];
        container.innerHTML = items.map(function(item) {
            return '<a class="fk-instagram-card" href="' + escapeHtml(item.url) + '" target="_blank" rel="noopener noreferrer" aria-label="Open ' + escapeHtml(item.label) + ' on Instagram"><img src="' + imageUrl(item.image) + '" alt="' + escapeHtml(item.label) + '" width="1080" height="1080" loading="lazy"><span class="fk-instagram-card__type">' + (item.type === "reel" ? "&#9654; Reel" : "Post") + "</span></a>";
        }).join("");
    }
    function cleanCart(raw) {
        var cleaned = {};
        return !raw || typeof raw != "object" || Object.keys(raw).forEach(function(id) {
            if (productById(id)) {
                var item = raw[id];
                typeof item == "number" && (item = {
                    display: item,
                    master_case: 0
                });
                var display = Math.min(500, Math.max(0, Math.floor(Number(item && item.display) || 0))), masterCase = Math.min(500, Math.max(0, Math.floor(Number(item && item.master_case) || 0)));
                (display || masterCase) && (cleaned[id] = {
                    display: display,
                    master_case: masterCase
                });
            }
        }), cleaned;
    }
    function readCart() {
        try {
            var stored = JSON.parse(window.sessionStorage.getItem(cartKey) || "null");
            return stored || (stored = JSON.parse(window.sessionStorage.getItem(legacyCartKey) || "{}"), 
            stored = cleanCart(stored), Object.keys(stored).length && window.sessionStorage.setItem(cartKey, JSON.stringify(stored))), 
            cleanCart(stored);
        } catch {
            return cleanCart(inMemoryCart);
        }
    }
    function writeCart(nextCart) {
        var cleaned = cleanCart(nextCart);
        inMemoryCart = cleaned;
        try {
            window.sessionStorage.setItem(cartKey, JSON.stringify(cleaned));
        } catch {}
        updateCartCount();
    }
    function cartCount() {
        return Object.values(readCart()).reduce(function(total, item) {
            return total + Number(item.display || 0) + Number(item.master_case || 0);
        }, 0);
    }
    function updateCartCount() {
        var count = cartCount();
        document.querySelectorAll("[data-fk-cart-count]").forEach(function(node) {
            node.textContent = String(count);
        }), document.querySelectorAll(".fk-cart-link").forEach(function(node) {
            node.setAttribute("aria-label", "Fronto King wholesale order request with " + count + " package units");
        });
    }
    function addProduct(id, unit, quantity) {
        var product = productById(id), safeUnit = unit === "master_case" ? "master_case" : "display";
        if (product) {
            var cart = readCart();
            cart[id] || (cart[id] = {
                display: 0,
                master_case: 0
            }), cart[id][safeUnit] = Math.min(500, cart[id][safeUnit] + Math.max(1, Math.floor(Number(quantity) || 1))), writeCart(cart), 
            renderAllCarts(), showToast(product.name + " " + unitLabel(product, safeUnit, !1) + " added to the wholesale order.");
        }
    }
    function changeQuantity(id, unit, quantity) {
        var cart = readCart();
        cart[id] || (cart[id] = {
            display: 0,
            master_case: 0
        }), cart[id][unit] = Math.min(500, Math.max(0, Math.floor(Number(quantity) || 0))), writeCart(cart), 
        renderAllCarts();
    }
    function cartLines() {
        var cart = readCart(), lines = [];
        return catalog().products.forEach(function(product) {
            var item = cart[product.id] || {};
            [ "display", "master_case" ].forEach(function(unit) {
                var quantity = Number(item[unit] || 0);
                quantity > 0 && lines.push({
                    product: product,
                    unit: unit,
                    quantity: quantity
                });
            });
        }), lines;
    }
    function renderCartLine(line) {
        var product = line.product, category = categoryById(product.category), key = product.id + ":" + line.unit;
        return '<article class="fk-review-cart-item" data-fk-cart-line="' + escapeHtml(key) + '"><button class="fk-review-cart-item__image" type="button" data-fk-quickview="' + escapeHtml(product.id) + '" data-fk-audience="wholesale"><img src="' + imageUrl(pairImage(product)) + '" alt="Fronto King ' + escapeHtml(product.name) + ' display and package front" width="340" height="240"></button><div class="fk-review-cart-item__details"><p class="fk-kicker">' + escapeHtml(category ? category.label : "Fronto King") + "</p><h2>" + escapeHtml(product.name) + "</h2><p>" + escapeHtml(unitLabel(product, line.unit, !0)) + '</p><div class="fk-quantity-control" aria-label="Quantity for ' + escapeHtml(product.name + " " + unitLabel(product, line.unit, !1)) + '"><button type="button" data-fk-decrease="' + escapeHtml(product.id) + '" data-fk-unit="' + line.unit + '" aria-label="Decrease quantity">&minus;</button><input type="number" min="1" max="500" value="' + line.quantity + '" data-fk-quantity="' + escapeHtml(product.id) + '" data-fk-unit="' + line.unit + '" aria-label="Quantity"><button type="button" data-fk-increase="' + escapeHtml(product.id) + '" data-fk-unit="' + line.unit + '" aria-label="Increase quantity">+</button></div></div><button class="fk-review-cart-item__remove" type="button" data-fk-remove="' + escapeHtml(product.id) + '" data-fk-unit="' + line.unit + '">Remove</button></article>';
    }
    function hustleVanCartUrl() {
        var items = cartLines().map(function(line) {
            return line.product.id + "~" + line.unit + ":" + line.quantity;
        }).join(",");
        return "https://account.hustlevan.com/?items=" + encodeURIComponent(items);
    }
    function checkoutMarkup() {
        return '<section class="fk-order-checkout" data-fk-checkout hidden aria-labelledby="FkCheckoutTitle"><div class="fk-order-checkout__heading"><p class="fk-kicker">Hustle Van business access</p><h2 id="FkCheckoutTitle">Continue to Hustle Van for prices and ordering.</h2><p>Your Fronto King display and master-case selections will move with you. Sign in, connect an existing account, or create a business profile there. Fronto King membership remains rewards-only.</p></div><div class="fk-form__actions"><a class="fk-button fk-button--gold" data-fk-hustlevan-checkout href="' + escapeHtml(hustleVanCartUrl()) + '">Continue to Hustle Van Business Account</a></div><p class="fk-form__note">No order is submitted here, and Fronto King does not collect business-account credentials or tobacco-license files.</p></section>';
    }
    function renderCart(container) {
        var lines = cartLines();
        if (!lines.length) {
            container.innerHTML = '<div class="fk-review-cart-empty"><div><h2>Your wholesale order is empty.</h2><p>Add displays or master cases from the Fronto King wholesale catalog, then return here to submit the business request.</p><a class="fk-button fk-button--gold" href="' + escapeHtml(container.dataset.shopUrl || route("wholesale")) + '">Browse wholesale products</a></div></div>';
            return;
        }
        var displayCount = lines.reduce(function(total, line) {
            return total + (line.unit === "display" ? line.quantity : 0);
        }, 0), caseCount = lines.reduce(function(total, line) {
            return total + (line.unit === "master_case" ? line.quantity : 0);
        }, 0), skuCount = new Set(lines.map(function(line) {
            return line.product.id;
        })).size;
        container.innerHTML = '<div class="fk-review-cart"><div class="fk-review-cart__items">' + lines.map(renderCartLine).join("") + '</div><aside class="fk-review-cart__summary"><p class="fk-kicker">Fronto King business selection</p><h2>Selection summary</h2><dl><div><dt>Products</dt><dd>' + skuCount + "</dd></div><div><dt>Displays</dt><dd>" + displayCount + "</dd></div><div><dt>Master cases</dt><dd>" + caseCount + '</dd></div></dl><p>Prices and ordering are available only through your Hustle Van business account.</p><a class="fk-button fk-button--gold" data-fk-hustlevan-checkout href="' + escapeHtml(hustleVanCartUrl()) + '">Continue to Hustle Van</a><p class="fk-form__note">No order is submitted here, and Fronto King does not collect business-account credentials or tobacco-license files.</p></aside></div>';
    }
    function renderAllCarts() {
        document.querySelectorAll("[data-fk-review-cart]").forEach(renderCart);
    }
    function ensureModal() {
        var modal = document.querySelector("[data-fk-catalog-modal]");
        return modal || (document.body.insertAdjacentHTML("beforeend", '<div class="fk-catalog-modal" data-fk-catalog-modal hidden><button class="fk-catalog-modal__backdrop" type="button" data-fk-modal-close aria-label="Close product view"></button><section class="fk-catalog-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="FkCatalogModalTitle"><button class="fk-catalog-modal__close" type="button" data-fk-modal-close aria-label="Close">&times;</button><div class="fk-catalog-modal__media"><img data-fk-modal-image src="" alt=""><div class="fk-catalog-modal__views" role="group" aria-label="Product image view"><button class="is-active" type="button" data-fk-image-view="pair">Both</button><button type="button" data-fk-image-view="display">Display</button><button type="button" data-fk-image-view="front">Package front</button></div></div><div class="fk-catalog-modal__copy"><p class="fk-kicker" data-fk-modal-category></p><h2 id="FkCatalogModalTitle" data-fk-modal-title></h2><p class="fk-catalog-modal__description" data-fk-modal-description></p><p class="fk-catalog-modal__format" data-fk-modal-format hidden></p><p class="fk-catalog-modal__note" data-fk-modal-note></p><div class="fk-catalog-modal__actions" data-fk-modal-wholesale hidden><button class="fk-button fk-button--gold" type="button" data-fk-modal-add="display">Add display</button><button class="fk-button fk-button--gold" type="button" data-fk-modal-add="master_case">Add master case</button><a class="fk-text-link" href="' + route("cart") + '">Review wholesale order</a></div><a class="fk-button fk-button--gold" href="' + route("locator") + '" data-fk-modal-consumer>Find a retailer</a></div></section></div>'), 
        document.querySelector("[data-fk-catalog-modal]"));
    }
    function setModalImage(mode) {
        var modal = ensureModal();
        if (activeProduct) {
            var useFront = mode === "front" && activeProduct.frontImage, usePair = mode === "pair", filename = usePair ? pairImage(activeProduct) : useFront ? activeProduct.frontImage : activeProduct.displayImage, image = modal.querySelector("[data-fk-modal-image]");
            image.src = imageUrl(filename), image.alt = "Fronto King " + activeProduct.name + (usePair ? " display and package front" : useFront ? " package front" : " display"), 
            modal.querySelectorAll("[data-fk-image-view]").forEach(function(button) {
                button.classList.toggle("is-active", button.dataset.fkImageView === (usePair ? "pair" : useFront ? "front" : "display"));
            });
        }
    }
    function openModal(id, trigger) {
        var product = productById(id);
        if (product) {
            activeProduct = product, activeAudience = trigger && trigger.dataset.fkAudience || trigger && trigger.closest("[data-fk-audience]") && trigger.closest("[data-fk-audience]").dataset.fkAudience || "consumer", 
            lastFocusedNode = trigger || document.activeElement;
            var modal = ensureModal(), category = categoryById(product.category), isWholesale = activeAudience === "wholesale";
            modal.querySelector("[data-fk-modal-category]").textContent = category ? category.label : "Fronto King", 
            modal.querySelector("[data-fk-modal-title]").textContent = product.name, modal.querySelector("[data-fk-modal-description]").textContent = product.description || (category ? category.copy : "Explore the current Fronto King lineup.");
            var format = modal.querySelector("[data-fk-modal-format]");
            format.textContent = isWholesale ? product.format : "", format.hidden = !isWholesale, 
            modal.querySelector("[data-fk-modal-note]").textContent = isWholesale ? "Choose a display or master case. Pricing and availability are confirmed after business review." : "Selection and availability may vary by retailer.", 
            modal.querySelector("[data-fk-modal-wholesale]").hidden = !isWholesale, modal.querySelector("[data-fk-modal-consumer]").hidden = isWholesale, 
            modal.querySelector('[data-fk-image-view="front"]').hidden = !product.frontImage, 
            modal.hidden = !1, document.body.classList.add("fk-modal-open"), setModalImage("pair"), 
            modal.querySelector(".fk-catalog-modal__close").focus();
        }
    }
    function closeModal() {
        var modal = document.querySelector("[data-fk-catalog-modal]");
        !modal || modal.hidden || (modal.hidden = !0, document.body.classList.remove("fk-modal-open"), 
        activeProduct = null, lastFocusedNode && typeof lastFocusedNode.focus == "function" && lastFocusedNode.focus());
    }
    function showToast(message) {
        var toast = document.querySelector("[data-fk-catalog-toast]");
        toast || (document.body.insertAdjacentHTML("beforeend", '<div class="fk-catalog-toast" data-fk-catalog-toast role="status" aria-live="polite"></div>'), 
        toast = document.querySelector("[data-fk-catalog-toast]")), toast.textContent = message, 
        toast.classList.add("is-visible"), window.clearTimeout(showToast.timeout), showToast.timeout = window.setTimeout(function() {
            toast.classList.remove("is-visible");
        }, 2600);
    }
    function refresh(root) {
        var scope = root || document;
        scope.querySelectorAll("[data-fk-category-nav]").forEach(renderCategoryNav), scope.querySelectorAll("[data-fk-catalog]").forEach(renderCatalog), 
        scope.querySelectorAll("[data-fk-instagram-grid]").forEach(renderInstagram), scope.querySelectorAll("[data-fk-review-cart]").forEach(renderCart), 
        updateCartCount();
    }
    document.addEventListener("click", function(event) {
        var quickView = event.target.closest("[data-fk-quickview]");
        if (quickView) {
            openModal(quickView.dataset.fkQuickview, quickView);
            return;
        }
        var add = event.target.closest("[data-fk-add]");
        if (add) {
            addProduct(add.dataset.fkAdd, add.dataset.fkUnit, 1);
            return;
        }
        if (event.target.closest("[data-fk-modal-close]")) {
            closeModal();
            return;
        }
        var imageView = event.target.closest("[data-fk-image-view]");
        if (imageView) {
            setModalImage(imageView.dataset.fkImageView);
            return;
        }
        var modalAdd = event.target.closest("[data-fk-modal-add]");
        if (modalAdd && activeProduct) {
            addProduct(activeProduct.id, modalAdd.dataset.fkModalAdd, 1);
            return;
        }
        var increase = event.target.closest("[data-fk-increase]");
        if (increase) {
            var increaseCart = readCart(), increaseItem = increaseCart[increase.dataset.fkIncrease] || {};
            changeQuantity(increase.dataset.fkIncrease, increase.dataset.fkUnit, Number(increaseItem[increase.dataset.fkUnit] || 0) + 1);
            return;
        }
        var decrease = event.target.closest("[data-fk-decrease]");
        if (decrease) {
            var decreaseCart = readCart(), decreaseItem = decreaseCart[decrease.dataset.fkDecrease] || {};
            changeQuantity(decrease.dataset.fkDecrease, decrease.dataset.fkUnit, Number(decreaseItem[decrease.dataset.fkUnit] || 0) - 1);
            return;
        }
        var remove = event.target.closest("[data-fk-remove]");
        if (remove) {
            changeQuantity(remove.dataset.fkRemove, remove.dataset.fkUnit, 0);
            return;
        }
        var checkoutButton = event.target.closest("[data-fk-open-checkout]");
        if (checkoutButton) {
            var cartRoot = checkoutButton.closest("[data-fk-review-cart]"), checkout = cartRoot && cartRoot.querySelector("[data-fk-checkout]");
            if (checkout) {
                checkout.hidden = !1;
                var firstAction = checkout.querySelector("[data-fk-hustlevan-checkout]");
                firstAction && firstAction.focus({
                    preventScroll: !0
                }), checkout.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            }
        }
    }), document.addEventListener("change", function(event) {
        var input = event.target.closest("[data-fk-quantity]");
        input && changeQuantity(input.dataset.fkQuantity, input.dataset.fkUnit, input.value);
    }), document.addEventListener("keydown", function(event) {
        event.key === "Escape" && closeModal();
    }), window.FKCatalogUI = {
        refresh: refresh,
        addProduct: addProduct,
        readCart: readCart,
        hustleVanCartUrl: hustleVanCartUrl
    }, document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", function() {
        refresh(document);
    }, {
        once: !0
    }) : refresh(document);
})();
